import { defineComponent as _defineComponent } from 'vue'
import OzBadge, { OzBadgeColorScheme } from '@@/library/v4/components/OzBadge.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzLoadingSpinner from '@@/library/v4/components/OzLoadingSpinner.vue'
import type { PlansState, UpgradeSource } from '@@/pinia/personal_plans_store'
import { PaymentSchedule, Tier } from '@@/pinia/personal_plans_store'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentScheduleTier',
  props: {
    plans: null,
    isLoadingPlanInformation: { type: Boolean },
    tier: null,
    paymentSchedule: null,
    upgradeSource: null,
    isExpanded: { type: Boolean },
    useTierColor: { type: Boolean, default: true }
  },
  emits: ['upgrade'],
  setup(__props: any, { emit }) {

const props = __props as { plans: PlansState['plans'], isLoadingPlanInformation: boolean, tier: Tier, paymentSchedule: PaymentSchedule, upgradeSource: UpgradeSource | null, isExpanded: boolean, useTierColor: boolean };





const buttonColorScheme = computed<OzContainedButtonColorScheme>(() => {
  if (!props.useTierColor) {
    return !props.isExpanded ? OzContainedButtonColorScheme.Secondary : OzContainedButtonColorScheme.Primary
  }
  if (props.tier === Tier.Gold) return OzContainedButtonColorScheme.Orange
  return OzContainedButtonColorScheme.Green
})

return { __sfc: true,emit, props, buttonColorScheme, OzBadge, OzBadgeColorScheme, OzContainedButton, OzIcon, OzLoadingSpinner, PaymentSchedule, Tier }
}

})